@if (showTierOneDashboard) {
  <div>
    <tier-one-dashboard></tier-one-dashboard>
  </div>
}
@if (showTierTwoDashboard) {
  <div>
    <tier-two-dashboard></tier-two-dashboard>
  </div>
}
@if (showTierThreeDashboard) {
  <div>
    <tier-three-dashboard></tier-three-dashboard>
  </div>
}